import { useState } from 'react';

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function PhoneInput({ value, onChange, className }: PhoneInputProps) {
  const formatPhone = (phone: string) => {
    const cleaned = phone.replace(/\D/g, '');
    
    // Se não tiver números, retorna vazio
    if (cleaned.length === 0) return '';
    
    // Sempre formata o DDD
    let formatted = `(${cleaned.slice(0, 2)}`;
    
    // Se tiver mais que 2 dígitos (após DDD)
    if (cleaned.length > 2) {
      formatted += ') ';
      
      // Para números com 8 dígitos: (XX) XXXX-XXXX
      if (cleaned.length <= 10) {
        formatted += cleaned.slice(2, 6);
        if (cleaned.length > 6) {
          formatted += `-${cleaned.slice(6, 10)}`;
        }
      }
      // Para números com 9 dígitos: (XX) XXXXX-XXXX
      else {
        formatted += cleaned.slice(2, 7);
        if (cleaned.length > 7) {
          formatted += `-${cleaned.slice(7, 11)}`;
        }
      }
    }

    return formatted;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhone(e.target.value);
    onChange(formatted);
  };

  return (
    <input
      type="tel"
      value={value}
      onChange={handleChange}
      placeholder="(00) 00000-0000"
      className={className}
      maxLength={15}
    />
  );
} 